import { useFetcher } from '@aviv-unified-frontend/runtime/fetcher';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { useServerRequest } from '@aviv-unified-frontend/runtime/lifecycle';
import { useSearchParams } from '@aviv-unified-frontend/runtime/router';
import { useBrandConfiguration } from '@search/core/brands/context';
import { useApis } from '@search/core/hooks/useApis';
import { useStageConfiguration } from '@search/core/hooks/useStageConfiguration';
import { useCallback } from 'react';
import { createLogger } from '../../helpers/createLogger';
import { compressToBase64, decompressFromBase64 } from './compressToBase64';
import { getInitSerpData } from './getInitSerpData';
const CACHE_KEY_PREFIX = 'classified-serp-init-data';
export const useInitSerpData = (appConfig) => {
    // FIXME: For this use case we'll be able to use the req prop in the useFetcher later on
    // To be fixed with https://github.com/axel-springer-kugawana/aviv_architecture_frontend_guild/pull/67 :fingers_crossed:
    const [searchParams] = useSearchParams();
    const logger = createLogger(appConfig.loggerName);
    if (searchParams?.has('locations') && [...searchParams].length === 1) {
        logger.warn('[useInitSerpData] SearchModel only contains `locations`', { searchParams: [...searchParams] });
    }
    let userId;
    try {
        const serverData = useServerRequest() ?? { data: { userId: undefined } };
        userId = serverData.data.userId;
    }
    catch (error) {
        logger.warn(`[getInitSerpData - getServerData]:  -> error: ${JSON.stringify(error)}`);
    }
    // const {
    //   data: { userId },
    // } = useServerRequest<ServerData>() ?? { data: { userId: undefined } }
    const { stage } = useStageConfiguration();
    const { bffUri } = useApis();
    const { language } = useLocale();
    const { defaultOrder, defaultPlaceId, featureFlags: consideredFeatureFlags, brand, pageSize, suggestionSlots = [], } = useBrandConfiguration();
    const callbackFetcher = useCallback(async () => {
        const initialData = await getInitSerpData({
            searchParams,
            stage,
            brand,
            pageSize,
            bffUri,
            language,
            defaultOrder,
            defaultPlaceId,
            consideredFeatureFlags,
            appConfig,
            numberOfSuggestions: suggestionSlots.length,
            userId,
        });
        return compressToBase64(initialData);
    }, []);
    const { data, error } = useFetcher(CACHE_KEY_PREFIX, callbackFetcher, {
        prefetching: true,
        strategy: 'cache-first',
    });
    return {
        data: decompressFromBase64(data),
        error,
    };
};
